import type { EmailContact } from "@stockline/shared/types/communications/email-contact"
import { EMAIL_CONTACT_TABLE } from "../../../lib/offline/resources/communications/email-contact/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

export interface UseEmailContactsFilter {
  userId?: string
  limit?: number
}

/**
 * Reactive list of email contacts from the Dexie cache.
 */
export function useEmailContacts(
  filter?: UseEmailContactsFilter
): EmailContact[] {
  const { reactive } = useAISync()
  return reactive.useQuery<EmailContact>(EMAIL_CONTACT_TABLE, {
    ...filter,
    limit: filter?.limit ?? 500,
  })
}

/**
 * Reactive single email-contact lookup by id.
 */
export function useEmailContact(id: string | null): EmailContact | null {
  const { reactive } = useAISync()
  return reactive.useOne<EmailContact>(EMAIL_CONTACT_TABLE, id ?? "__none__")
}
